import { render } from "./activation.vue?vue&type=template&id=b9770706&scoped=true"
import script from "./activation.vue?vue&type=script&lang=js"
export * from "./activation.vue?vue&type=script&lang=js"

import "./activation.vue?vue&type=style&index=0&id=b9770706&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9770706"]])

export default __exports__